/** Get a list of feeds */
export const feedListSpec = {
    uri: '/t/[tenant]/feed',
    method: 'GET',
};
